import {t} from 'i18next';
import IndexOverView from '../IndexingOverview/IndexingOverview';
import AurBreadcrumb from '../../common/aur-breadcrumb/AurBreadCrumb';
import IndexingBanner from '../IndexManagement/IndexingBanner';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {Box} from '@mui/material';
import {EciHomePageTabs} from '../../../constants/constants';

const CustomIndexOverView = () => {
  const breadCrumbItems = [
    {
      label: t('eca.ecaHomepage.coreEciHome'),
      path: `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`,
    },
    {
      label: t('ecaIndexing.manageIndexes'),
      path: '/indexmanagement',
    },
    {
      label: t('common.customIndex'),
    },
  ];
  const indexing = useSelector(
    (state: RootState) => state.indexesBanner.indexBannerData
  );
  const indexingType = useSelector(
    (state: RootState) => state.indexes.indexData.ele.name
  );
  return (
    <div className="index-main-container">
      <div className="index-banner-container">
        {indexing.showIndexBanner ? (
          <IndexingBanner message={indexing.message} />
        ) : null}
      </div>
      <Box
        data-testid="breadcrumb-container"
        className={indexing.showIndexBanner ? '' : 'empty-index'}
      >
        <AurBreadcrumb items={breadCrumbItems} />
      </Box>
      <IndexOverView title={indexingType} />
    </div>
  );
};

export default CustomIndexOverView;
